import { defineComponent as _defineComponent } from 'vue'
import { TalentProfileStatuses } from '~/lib/talentProfileEnums'
import { computed } from '@nuxtjs/composition-api'
import { useUserStore } from '~/store/userStore'
import { useLayoutInfo } from '~/lib/composables/useLayoutInfo'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    mobileMenuOpen: { type: Boolean },
    isHotlistActive: { type: Boolean },
    isHotlistStatusPopupOpen: { type: Boolean },
    isHotlistStatusUpdating: { type: Boolean }
  },
  emits: ["hamburger-button-clicked", "hotlist-status-toggle-clicked"],
  setup(__props: any) {





const user = useUserStore()
const showHotlistStatusButton = computed(
  // TODO show the hotlist status button also if they are pending, but just disable it
  () => user.talent?.profileStatus === TalentProfileStatuses.Approved
)

const { isMobileLayout } = useLayoutInfo()

return { __sfc: true,user, showHotlistStatusButton, isMobileLayout }
}

})